// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__2ikF9","number":"Question_number__1wUgU","mainWrapper":"Question_mainWrapper__3i4QJ","addAnswerButton":"Question_addAnswerButton__3zEvO"};